"use strict";

import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "semantic-ui-less/semantic.less";
import "./app.less";
import "react-semantic-toasts/styles/react-semantic-alert.css";

import TapeChart from "./pages/TapeChart";
import YieldPopup from "./components/YieldPopup";
import BankDeposits from "./pages/BankDeposit";
import BankDepositsReport from "./components/Reports/BankDeposit";
import MainMenu from "./components/MainMenu";
import KeyMakerPopup from "./components/KeyMakerPopup";
import Reports from "./components/Reports";
import AnalyticsUserMapping from "./pages/AnalyticsUserMapping";
import CustomerChannelMapping from "./components/CustomerChannelMapping";
import StoryBoard from "./pages/StoryBoard";
import LanguageContext from "./language";
import RestrictionsPopup from "./components/RestrictionsPopup";
import PriceUpdatePopup from "./components/PriceUpdatePopup";
import { GetResources } from "./api/services/shell";
import { Nationalities } from "./api/services/next";
import PyramidReportsTabs from "./pages/PyramidReportsTabs";
import CumulativeDetailedIncomeReport from "./components/Reports/CumulativeDetailedIncomeReport";
import GroupReservation from "./pages/GroupReservation";
import ApartmentOwnersPortal from "./pages/ApartmentOwnersPortal";
import ApartmentsOwnersPortalMenu from "./pages/ApartmentOwnersPortal/menu";
import AddonsByReservationReport from "./components/Reports/AddonsByReservation";
import AddonsCommissionsReport from "./components/Reports/AddonsCommissions";
import { SemanticToastContainer } from "react-semantic-toasts";
import ApplicationContext from "./context";
import ColorPicker from "./components/shared/ColorPicker";
import ImportExcelPage from "./pages/ImportExcel";
import ReservationPage from "./pages/Reservation";
import PageHeader from "./components/PageHeader";
import { onError, onNote, onSuccess, onWarning } from "./components/shared/messages";
import FolioSideTabs from "./components/FolioSideTabs";
import { AddCardPopup, MakePaymentPopup } from "./components/Payment";
import ProformaPopup from "./pages/Folio/proforma";
import DetailedCashReport from "./components/Reports/DetailedCash";
import { HomePage } from "./pages/Home";
import ReceiptPopup from "./components/ReceiptPopup/index";
import AddPaymentTransactionPopup from "./components/AddPaymentTransactionPopup";
import CustomerDropDown from "./components/shared/CustomerDropDown";
import { DashBoard } from "./pages/DashBoard";
import DefaultHomePageDropDown from "./components/shared/DefaultHomePageDropDown";
import CheckTaxExemptionPopup from "./components/CheckTaxExemptionPopup";
import OccupancyForecastReport from "./components/Reports/DaysForecast/OccupancyForecast";
import AddonsForecastReport from "./components/Reports/DaysForecast/AddonsForecast";
import GuestsForecastReport from "./components/Reports/DaysForecast/GuestsForecast";
import RoomsForecastReport from "./components/Reports/DaysForecast/RoomsForecast";
import CancelReservationsReport from "./components/Reports/CancelReservations";
import ReservationSearch from "./pages/Reservation/search.js";
import ReservationsByCheckInDateForHotelOwnerReport from "./components/Reports/Reservations/ReservationsByCheckInDateForHotelOwner";
import HousekeepingReport from "./components/Reports/HouseKeeping";
import ReservationPolicy from "./pages/ReservationPolicy";
import GroupReservationsByCheckInDateReport from "./components/Reports/Groups/GroupReservationsByCheckInDate";
import { EmailSettings } from "./pages/EmailSettings";
import Tags from "./pages/Tags";
import { GuestReport } from "./components/Reports/Guest";
import InvoicesReceiptsReport from "./components/Reports/InvoicesReceipts";
import { RMSRulesPage } from './pages/RMSRules'
import MultipleCommissionPopup from "./components/CustomerCommission/index";
import { ExpensesManagementPage } from './pages/Expenses'
import { ApartmentOwnerReport } from "./components/Reports/ApartmentOwner";
import { CustomerIncomeReport } from "./components/Reports/CustomerIncome";
import { DocumentSeriesPage } from './pages/DocumentSeries'
import AccountingSystemReport from "./components/Reports/AccountingSystem"
import FolioPendingPopup from './components/FolioPendingPopup/FolioPendingPopup'
import { HotelCurrencyPage } from './pages/HotelCurrency'
import { LoginPage } from './pages/Login'
import ChangePasswordPage from './pages/ChangePassword'
import { LoginTwoFactorPage } from './pages/Login/TwoFactor'
import ShortReservationPopup from './components/ShortReservationPopup'
import { AccountingSystemMappingPage } from './pages/AccountingSystemMappingPage';
import ReceptionAnywhere from './pages/ReceptionAnywhere';
import ArrivalsAndGuestInHouseSearch from "./components/ArrivalsAndGIHSearch";
import SendMailPopup from './components/SendMailPopup/index'
import PendingFoliosReport from "./components/Reports/PendingFolios";
import IsraelTaxAuthority from './pages/IsraelTaxAuthority';
import { GetAgentUrl } from "./api/services/pms.js";
import AvailabilityPage from "./pages/Availability/index.js";
import PasswordInput from "./components/shared/PasswordInput";
import RefundPopup from "./components/RefundPopup/index.js";
import RefusedInvoiceTreatmentPopup from "./components/RefusedInvoiceTreatmentPopup/index.js";
const components = {
  ReceiptPopup,
  TapeChart,
  YieldPopup,
  BankDepositsReport,
  BankDeposits,
  MainMenu,
  KeyMakerPopup,
  Reports,
  AnalyticsUserMapping,
  CustomerChannelMapping,
  StoryBoard,
  RestrictionsPopup,
  PriceUpdatePopup,
  PyramidReportsTabs,
  CumulativeDetailedIncomeReport,
  GroupReservation,
  ApartmentOwnersPortal,
  ApartmentsOwnersPortalMenu,
  AddonsByReservationReport,
  AddonsCommissionsReport,
  SemanticToastContainer,
  ColorPicker,
  ImportExcelPage,
  ReservationPage,
  PageHeader,
  FolioSideTabs,
  AddCardPopup,
  MakePaymentPopup,
  ProformaPopup,
  DetailedCashReport,
  OccupancyForecastReport,
  AddonsForecastReport,
  GuestsForecastReport,
  RoomsForecastReport,
  HomePage,
  AddPaymentTransactionPopup,
  CustomerDropDown,
  DashBoard,
  DefaultHomePageDropDown,
  CheckTaxExemptionPopup,
  ReservationSearch,
  CancelReservationsReport,
  ReservationsByCheckInDateForHotelOwnerReport,
  HousekeepingReport,
  ReservationPolicy,
  GroupReservationsByCheckInDateReport,
  EmailSettings,
  GuestReport,
  Tags,
  InvoicesReceiptsReport,
  RMSRulesPage,
  MultipleCommissionPopup,
  ExpensesManagementPage,
  AccountingSystemReport,
  ApartmentOwnerReport,
  CustomerIncomeReport,
  FolioPendingPopup,
  HotelCurrencyPage,
  LoginPage,
  LoginTwoFactorPage,
  ChangePasswordPage,
  ShortReservationPopup,
  DocumentSeriesPage,
  AccountingSystemMappingPage,
  ReceptionAnywhere,
  ArrivalsAndGuestInHouseSearch,
  SendMailPopup,
  PendingFoliosReport,
  IsraelTaxAuthority,
  AvailabilityPage,
  PasswordInput,
  RefundPopup,
  RefusedInvoiceTreatmentPopup
}

let language = null;
export async function render(component, container, props) {
  if (language === null) {
    if (window.optima && window.optima.resourceManager) {
      language = window.optima.resourceManager;
    } else if (window.resourceManager) {
      language = window.resourceManager;
    } else {
      /* eslint-disable require-atomic-updates */
      try {
        language = await GetResources();
      } catch (e) {
        console.error(e);
      }
      /* eslint-enable require-atomic-updates */
    }
  }

  let element = container;
  if (typeof container === "string") {
    element = document.getElementById(container);
  }
  if (element) {
    const ComponentTag = components[component];
    const AppWrapper = () => {
      const [state, setAppState] = useState({
        loader: false,
        user: null,
        counter: 0,
        nationalities: [],
        agentUrl: '',
        agentState: "OptimaAgentNotFound"
      });

      // Test the optima agent state
      useEffect(() => {
        (async () => {
          try {
            // Get Agent URL
            var url = await GetAgentUrl();

            if (url) {
              // Get Agent Version
              var response = await fetch(url + "agent/version", {
                method: "POST",
                headers: {
                  "JWT": "eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJPcHRpbWEiOiJBZ2VudCIsImlzcyI6IlNpbHZlcmJ5dGUgTFREIn0.RtSAH6MP-Ca3N35v5h9CFF5VuhHDZuTnuIp85VYUUpI"
                },
              })

              // Set Agent version and URL to app state
              if (response) {
                var result = await response.json()
                setAppState((prevState) => ({
                  ...prevState,
                  agentUrl: url,
                  agentState: result,
                }));
              }
            }
          } catch (error) {
            setAppState((prevState) => ({ ...prevState, agentState: "OptimaAgentNotFound" }));
          }
        })()
      }, [])

      const [cprops, setCprops] = useState(props);
      // Recieve external updates
      useEffect(() => {
        window.addEventListener("message", (message) => {
          const data = message.data;
          if (
            data.type === "UpdateComponentProps" &&
            data.component === component
          ) {
            setCprops({
              ...cprops,
              ...data.props,
            });
          }
        });
      }, []);

      useEffect(() => {
        (async () => {
          try {
            const nationalities = await Nationalities.GetNationalities();
            setState((prevState) => ({ ...prevState, nationalities }));
          } catch (error) {
            console.log(error)
          }
        })();
      }, []);

      const setState = (state) => {
        if (state.user) {
          window.$user = state.user;
        }

        setAppState(state);
      };

      return (
        <LanguageContext.Provider value={language}>
          <ApplicationContext.Provider value={{ state, setState }}>
            <ComponentTag {...cprops} />
            <div id="portal-container" />
            {/*Enables injection of other components from other places in the system without overriding
            the current used tree of the DOM by using:
            Optima2React.render(COMPONENT-NAME, "portal-container", {props}*/}
          </ApplicationContext.Provider>
        </LanguageContext.Provider>
      );
    };
    ReactDOM.render(<AppWrapper />, element);
  } else {
    console.error("Container element could not be found or null: " + container);
  }
}

export function toastError(error) {
  onError(error);
}

export function toastWarning(error) {
  onWarning(error);
}

export function toastSuccess(title) {
  onSuccess(title);
}

export function toastNote(props) {
  onNote(props);
}

export async function toastContainer() {
  const toast = document.createElement("div");
  document.body.appendChild(toast);
  render("SemanticToastContainer", toast);
}

